module.exports = __webpack_public_path__ + "img/plan3_book01.64be1b7c.png";